import ROUTE from "@app/navigationApp/routes";

export enum APPLICATION_STATE {
    COMPLETED = "COMPLETED",
    IN_PROGRESS = "IN_PROGRESS",
    NOT_STARTED = "NOT_STARTED",
    BLOCKED = 'BLOCKED',
    DENIED = 'DENIED'
}

export enum LENDER_ID {
    TATA = 'tata',
    BAJAJ = 'bajaj',
    DSP = 'dsp'
}
export const enum AppPlatform {
    SDK_INVESTWELL = 'SDK_INVESTWELL',
    FREO = 'FREO',
    PHONEPE = "PHONEPE",
    BHARATPE = "BHARAT_PE",
    JUPITER = 'JUPITER',
    BHARAT_PE="BHARAT_PE",
    PARK_PLUS= "PARKPLUS",
    NIYO = "NIYO",
    TDL = 'TATADIGITAL',
    ZYPE = 'ZYPE',
    PRUDENT = 'PRUDENT',
    BHARAT_PE_2 = 'BHARAT_PE_2'
}

// export const halfJourneyRoutes = [ROUTE.EMAIL_VERIFY, ROUTE.PAN_CONFIRM_NAME, ROUTE.MF_FETCH_PORTFOLIO, ROUTE.MF_PLEDGE_PORTFOLIO, ROUTE.SET_CREDIT_LIMIT, ROUTE.CHECKING_LIMIT, ROUTE.KYC_PAN_VERIFICATION]
export const halfJourneyPlatformSupport = [AppPlatform.BHARATPE,AppPlatform.BHARAT_PE_2,AppPlatform.PHONEPE];
export const showSupportNumberForPartner = [AppPlatform.ZYPE,AppPlatform.PRUDENT,AppPlatform.JUPITER,AppPlatform.TDL]
export const skipGmailEnter = [AppPlatform.JUPITER, AppPlatform.BHARATPE ,AppPlatform.BHARAT_PE_2 ,AppPlatform.PARK_PLUS,AppPlatform.TDL ,AppPlatform.PHONEPE,AppPlatform.SDK_INVESTWELL]


export const LENDER_DISPLAY_NAME_MAP = {
    "Tata" : "Tata Capital",
    "DSP" : "DSP Finance",
    "Bajaj" : "Bajaj Finance",
  }
export const nextRouteDeterminer  = () =>{

}

export const routingManager = () =>{
    
}